<template>
  <div v-if="currentUser && currentUser.name">
    <el-dropdown trigger="click" @command="handleCommand">
      <span class="account-avatar">
     
          <img src="@/assets/头像.png"
          class="avatar" </img>
        
        <span class="username">{{ currentUser.name }}</span>
        <el-icon class="el-icon--right"><ArrowDown /></el-icon>
      </span>
      <template #dropdown>
        <el-dropdown-menu class="dropdown-menu">
          <el-dropdown-item v-if="menu" divided command="logout">
            <el-icon><SwitchButton /></el-icon>
            <span>退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
  <span v-else>
    <el-icon class="is-loading" :style="{ marginLeft: 8, marginRight: 8 }">
      <Loading />
    </el-icon>
  </span>
</template>

<script>
import { ElMessageBox, ElMessage } from 'element-plus'
import { ArrowDown, SwitchButton, Loading } from '@element-plus/icons-vue'

export default {
  name: 'AvatarDropdown',
  components: {
    ArrowDown,
    SwitchButton,
    Loading
  },
  props: {
    currentUser: {
      type: Object,
      default: () => null
    },
    menu: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleCommand(command) {
      if (command === 'logout') {
        this.handleLogout()
      }
    },
    handleLogout() {
      ElMessageBox.confirm(
        this.$t ? this.$t('layouts.usermenu.dialog.content') : '确定要退出登录吗？',
        this.$t ? this.$t('layouts.usermenu.dialog.title') : '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        localStorage.removeItem('userData')
        localStorage.removeItem('token')
        localStorage.removeItem('activeMenuIndex')
        
        if (this.$store && this.$store.dispatch) {
          return this.$store.dispatch('Logout').then(() => {
            setTimeout(() => {
              if (this.$router) {
                this.$router.push({ name: 'login' })
              }
              ElMessage.success({
                message: '退出登录',
                duration: 2000
              })
            }, 1000)
          })
        } else {
          if (this.$router) {
            this.$router.push({ path: '/login' })
          }
          ElMessage.success({
            message: '退出登录',
            duration: 2000
          })
        }
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
.account-avatar {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 12px;
}

.avatar {
  margin-right: 8px;
  width:32px;
  height: 32px;
}

.username {
  margin-right: 8px;
  font-size: 14px;
}

.dropdown-menu {
  min-width: 160px;
}

.dropdown-menu :deep(.el-dropdown-menu__item) {
  display: flex;
  align-items: center;
}

.dropdown-menu :deep(.el-icon) {
  margin-right: 8px;
}

.is-loading {
  animation: rotating 2s linear infinite;
}

@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
